/* eslint-disable react/require-default-props */
import { ReactNode } from 'react';

import { Card } from '@heroui/react';
import './borderedCard.css';

export interface BorderedCardProps {
  children: ReactNode;
  isBlurred?: boolean;
  isPressable?: boolean;
  isHoverable?: boolean;
  onPress?: () => void;
}

const BorderedCard = ({
  children,
  isBlurred = true,
  isPressable = true,
  isHoverable = true,
  onPress = () => {},
}: BorderedCardProps) => {
  return (
    <div className="star-border-container rounded-lg">
      <Card
        isBlurred={isBlurred}
        isPressable={isPressable}
        isHoverable={isHoverable}
        className="relative w-full h-full rounded-lg bg-transparent!"
        onPress={onPress}
      >
        <div
          className="border-gradient-bottom rounded-lg"
          style={{
            background: 'radial-gradient(circle, #000, transparent 10%)',
          }}
        />
        <div
          className="border-gradient-top rounded-lg"
          style={{
            background: 'radial-gradient(circle, #000, transparent 10%)',
          }}
        />
        <div className="inner-content rounded-lg bg-transparent">{children}</div>
      </Card>
    </div>
  );
};

export default BorderedCard;
